import { Button, Card, CardContent, CardHeader } from "@nymbl/nos2-rules";

/** What `/signup` shows when the app doesn't let people make their own account. */
export function SignupClosed() {
  return (
    <Card>
      <CardHeader className="space-y-1 text-center pb-2">
        <h1 className="font-display text-3xl font-bold">Accounts are by invitation</h1>
        <p className="text-muted-foreground text-sm">
          Ask an admin of this app to create an account for you.
        </p>
      </CardHeader>
      <CardContent>
        <p className="text-center text-sm text-muted-foreground mt-2">
          Already have one?{" "}
          <Button asChild variant="link" className="h-auto p-0">
            <a href="/login">Sign in</a>
          </Button>
        </p>
      </CardContent>
    </Card>
  );
}
